import { render, staticRenderFns } from "./OmrDetailPopup.vue?vue&type=template&id=d6ba0da4&scoped=true&"
import script from "./OmrDetailPopup.vue?vue&type=script&lang=js&"
export * from "./OmrDetailPopup.vue?vue&type=script&lang=js&"
import style0 from "./OmrDetailPopup.vue?vue&type=style&index=0&id=d6ba0da4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6ba0da4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VCol,VContainer,VDataTable,VIcon,VRow,VTextField,VTooltip})
